@if (show()) {
  <div class="processing-overlay">
    <div class="processing-content">
      <img
        src="/assets/images/logo/logo_datameal_short_outline.png"
        alt="Logo DataMeal"
        class="processing-logo mx-auto"
      />
      <div class="spinner"></div>
      <p class="processing-message">{{ 'sync.processing' | translate }}</p>
    </div>
  </div>
}
